import { TERMS } from '../constants';
import Item from '../Item';

const Terms = () => (
  <>
    <h3 className="font-subtitle3 w-full text-left mb-16">Condiciones:</h3>

    <ul className="mb-32">
      {TERMS.map(({ paragraph, shouldParser }, key) => (
        // eslint-disable-next-line react/no-array-index-key
        // biome-ignore lint/suspicious/noArrayIndexKey: legacy code - suspicious/noArrayIndexKey
        <Item paragraph={paragraph} shouldParser={shouldParser} key={key} />
      ))}
    </ul>
  </>
);

export default Terms;
